// ABOUTME: Mobile navigation bar header with hamburger menu button and right-side actions
// ABOUTME: Visible only on mobile via md:hidden, rendered inside the Navigation shell
import { Button, icon } from "@hm/fundamental"
import React from "react"
import { useTranslation } from "react-i18next"

import { useNavigationContext } from "../NavigationContext"
import type { NavigationTabsProps } from "../types"

interface MobileNavProps {
	navigationTabs: NavigationTabsProps[] | undefined
	rightSideButtonsMobile?: React.ReactNode
	children?: React.ReactNode
}

export const MobileNav: React.FC<MobileNavProps> = ({
	navigationTabs,
	rightSideButtonsMobile,
	children,
}) => {
	const { t } = useTranslation("shared", { keyPrefix: "navigation" })
	const { toggleMobileMenu, isMenuOpened, menuButtonRef } =
		useNavigationContext()

	return (
		<div className="flex md:hidden justify-between items-center w-full">
			<div className="flex-shrink-0">
				{navigationTabs && navigationTabs.length > 0 && (
					<Button
						variant="secondary"
						icon={icon.mdiMenu}
						round
						square
						onClick={toggleMobileMenu}
						ref={menuButtonRef}
						aria-label={t("moreLabel")}
						aria-expanded={isMenuOpened}
						data-cy="menu-button"
					/>
				)}
			</div>

			<div className="flex-1 flex justify-center">
				<div className="inline-block align-middle">{children}</div>
			</div>

			<div className="flex-shrink-0 flex gap-x-[10px]">
				{rightSideButtonsMobile}
			</div>
		</div>
	)
}
